// Centralised data-testid catalog
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  root: "site-header",
  logo: "header-logo",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkServices: "nav-link-services",
  linkProducts: "nav-link-products",
  linkMarkets: "nav-link-markets",
  linkFaq: "nav-link-faq",
  linkQuote: "nav-link-quote",
  linkContact: "nav-link-contact",
  ctaQuote: "header-cta-quote",
  langSwitcher: "language-switcher",
  langItButton: "language-switcher-it",
  langEnButton: "language-switcher-en",
  mobileToggle: "mobile-menu-toggle",
  mobileMenu: "mobile-menu",
};

export const HERO = {
  root: "hero-section",
  ctaQuote: "hero-cta-quote",
  ctaCatalog: "hero-cta-catalog",
};

export const PRODUCTS = {
  root: "products-section",
  tabs: "products-tabs",
  tabBeverages: "products-tab-beverages",
  tabSweet: "products-tab-sweet",
  tabSalty: "products-tab-salty",
  search: "products-search-input",
  item: (id) => `product-item-${id}`,
  ctaQuote: "products-cta-quote",
};

export const QUOTE_FORM = {
  root: "quote-form",
  company: "quote-input-company",
  contactName: "quote-input-contact-name",
  email: "quote-input-email",
  phone: "quote-input-phone",
  country: "quote-input-country",
  catBeverages: "quote-cat-beverages",
  catSweet: "quote-cat-sweet",
  catSalty: "quote-cat-salty",
  catOther: "quote-cat-other",
  products: "quote-input-products",
  quantity: "quote-input-quantity",
  message: "quote-input-message",
  submit: "quote-submit-button",
  success: "quote-success-message",
};

export const CONTACT_FORM = {
  root: "contact-form",
  name: "contact-input-name",
  email: "contact-input-email",
  company: "contact-input-company",
  phone: "contact-input-phone",
  subject: "contact-input-subject",
  message: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
};

export const FAQ = {
  root: "faq-section",
  item: (i) => `faq-item-${i}`,
};

export const FOOTER = {
  root: "site-footer",
};
